const formatter = Intl.NumberFormat('en', { notation: 'compact' });

const formatIfNan = (row, selector) => {
  return isNaN(row[selector]) ? 'N/A' : formatter.format(row[selector]);
};

export default formatIfNan;
